function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.078,
  cy: 98.1881,
  rx: 20.4115,
  ry: 20.4302,
  fill: "#48DBB4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M88.0781 77.7578C76.8088 77.7578 67.6665 86.9085 67.6665 98.1881C67.6665 109.468 76.8088 118.618 88.0781 118.618C99.3473 118.618 108.49 109.468 108.49 98.1881C108.472 86.9085 99.3301 77.7578 88.0781 77.7578ZM96.62 93.6213H95.3507L91.4571 98.1709L95.3507 102.72H96.6372V106.377H88.3696V102.755H89.6561L87.1004 99.7675H86.054V102.755H87.512V106.377H79.5018V102.72H81.2342V98.1881V93.6213H79.5018V89.9645H81.4743V91.3208H82.5378V89.9645H84.476V91.3208H85.5395V89.9645H87.4949V93.5698H86.0369V96.5571H87.0832L89.6389 93.5698H88.3525V89.9645H96.62V93.6213Z",
  fill: "#0A0806"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0667 117.45C27.0667 118.785 25.9848 119.867 24.6501 119.867C23.3154 119.867 22.2334 118.785 22.2334 117.45C22.2334 116.115 23.3154 115.033 24.6501 115.033C25.9848 115.033 27.0667 116.115 27.0667 117.45Z",
  fill: "#FF9900"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M106.349 42.5334C106.349 43.6012 105.48 44.4668 104.408 44.4668C103.336 44.4668 102.467 43.6012 102.467 42.5334C102.467 41.4657 103.336 40.6001 104.408 40.6001C105.48 40.6001 106.349 41.4657 106.349 42.5334Z",
  fill: "#FF9900"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M116 28.9886C116 30.5838 114.702 31.877 113.1 31.877C111.499 31.877 110.2 30.5838 110.2 28.9886C110.2 27.3933 111.499 26.1001 113.1 26.1001C114.702 26.1001 116 27.3933 116 28.9886Z",
  fill: "#FFCE88"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7868 103.38C36.7868 102.342 37.6283 101.5 38.6664 101.5C39.7045 101.5 40.5461 102.342 40.5461 103.38L40.5461 106.387H43.5535C44.5916 106.387 45.4331 107.229 45.4331 108.267C45.4331 109.305 44.5916 110.146 43.5535 110.146H40.5461L40.5461 113.154C40.5461 114.192 39.7045 115.033 38.6664 115.033C37.6283 115.033 36.7868 114.192 36.7868 113.154V110.146H33.7794C32.7413 110.146 31.8998 109.305 31.8998 108.267C31.8998 107.229 32.7413 106.387 33.7794 106.387H36.7868V103.38Z",
  fill: "#FFCE88"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M92.6387 4.02778C92.6387 1.8033 94.442 1.4621e-06 96.6665 1.26763e-06C98.891 1.07316e-06 100.694 1.8033 100.694 4.02778L100.694 10.4722L107.139 10.4722C109.363 10.4722 111.167 12.2755 111.167 14.5C111.167 16.7245 109.363 18.5278 107.139 18.5278L100.694 18.5278L100.694 24.9722C100.694 27.1967 98.891 29 96.6665 29C94.442 29 92.6387 27.1967 92.6387 24.9722L92.6387 18.5278L86.1943 18.5278C83.9698 18.5278 82.1665 16.7245 82.1665 14.5C82.1665 12.2755 83.9698 10.4722 86.1943 10.4722L92.6387 10.4722L92.6387 4.02778Z",
  fill: "#FF9900"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6594 11.6562L61.1509 13.1689L61.1504 13.1724C83.6591 16.3935 99.254 37.8049 96.0463 61.2253C92.8387 84.6457 72.035 101.266 49.4569 98.5522L49.422 98.5475C49.2814 98.5305 49.1408 98.5127 49.0001 98.4942C48.7079 98.4557 48.4176 98.415 48.1293 98.372L37.9717 96.9935L38.1427 95.7448L49.6594 11.6562Z",
  fill: "#B1BCCC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M50.0409 11.7083L61.4485 13.21L61.448 13.2135C83.792 16.413 99.254 37.8069 96.0463 61.2273C92.8387 84.6477 72.1679 101.286 49.7544 98.5933L49.7198 98.5886C49.5802 98.5717 49.4406 98.5541 49.301 98.5357C49.0109 98.4975 48.7228 98.4571 48.4365 98.4144L38.3531 97.0457L38.5241 95.797L50.0409 11.7083Z",
  fill: "#F6F7FA"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_12483_97919)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 43.3676,
  height: 85.7274,
  transform: "matrix(0.389327 -0.922526 -0.946066 -0.320878 100.019 110.82)",
  fill: "#718096"
}), /*#__PURE__*/React.createElement("rect", {
  width: 43.3676,
  height: 85.7274,
  transform: "matrix(0.389327 -0.922526 -0.946066 -0.320878 85.1313 136.205)",
  fill: "#323A47"
}));

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 40.8421,
  ry: 42.352,
  transform: "matrix(-0.991447 -0.130513 -0.135693 0.990751 46.2818 55.1101)",
  fill: "#F6F7FA"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 45.6303,
  cy: 54.7389,
  rx: 43.4413,
  ry: 43.5187,
  fill: "#E2E8F0"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12483_97919)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.9711 40.2327H54.0795V45.8728H70.9711V40.2327ZM42.8151 45.8728H37.1845V51.5164H42.8151V45.8728ZM37.1845 74.0805H42.8151V57.1566H37.1845V74.0805ZM48.4456 45.8728V51.5164H54.0795V45.8728H48.4456ZM48.4456 74.0805H54.0795V57.1566H48.4456V74.0805ZM48.4456 40.2327H42.8151V45.8728H48.4456V40.2327ZM20.2896 40.2327V45.8728H37.1845V40.2327H20.2896ZM70.9711 57.1566V51.5164H54.0795V57.1566H70.9711ZM42.8151 51.5164V57.1566H48.4456V51.5164H42.8151ZM20.2896 51.5164V57.1566H37.1845V51.5164H20.2896Z",
  fill: "#0A0806"
}));

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 45.56,
  cy: 55.2632,
  rx: 37.9316,
  ry: 37.9722,
  stroke: "#C5CEDC",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeDasharray: "0.5 5"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8623 83.3214C12.8623 81.6159 14.2448 80.2334 15.9502 80.2334C17.6557 80.2334 19.0382 81.6159 19.0382 83.3214L19.0382 88.2621L23.9789 88.2621C25.6844 88.2621 27.0669 89.6446 27.0669 91.3501C27.0669 93.0555 25.6844 94.438 23.9789 94.438L19.0382 94.438L19.0382 99.3788C19.0382 101.084 17.6557 102.467 15.9502 102.467C14.2448 102.467 12.8623 101.084 12.8623 99.3788L12.8623 94.438L7.92152 94.438C6.21609 94.438 4.83356 93.0555 4.83356 91.3501C4.83356 89.6446 6.21609 88.2621 7.92152 88.2621L12.8623 88.2621L12.8623 83.3214Z",
  fill: "#FF9900"
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12483_97919"
}, /*#__PURE__*/React.createElement("rect", {
  width: 50.6815,
  height: 33.8479,
  fill: "white",
  transform: "translate(20.2896 40.2327)"
})));

const SvgKeepTUpgradeLogo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 120,
    viewBox: "0 0 116 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12483_97919",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 11,
    width: 59,
    height: 88
  }, _ref10), _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeepTUpgradeLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keep-t-upgrade-logo.cdd24aec.svg";
export { ForwardRef as ReactComponent };